export default __webpack_public_path__ + "static/media/page-decoration-1.aba68a5f.svg";